var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounterOfferMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37715_58698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H32V32H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37715_58698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3124 0.687504C11.3036 0.687504 7.65528 2.22869 4.92578 4.75V27.25C7.65528 29.7713 11.3036 31.3125 15.3124 31.3125C23.7693 31.3125 30.6249 24.4569 30.6249 16C30.6249 7.54313 23.7693 0.687504 15.3124 0.687504Z",
    fill: "#543E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 16C25.6914 22.9036 20.095 28.5 13.1914 28.5C6.28784 28.5 0.691406 22.9036 0.691406 16C0.691406 9.09644 6.28784 3.5 13.1914 3.5C20.095 3.5 25.6914 9.09644 25.6914 16Z",
    fill: "#442F4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5001 4.75H4.92512C4.11149 5.50138 3.38049 6.34062 2.74512 7.2515V24.7485C3.38049 25.6594 4.11149 26.4986 4.92512 27.25H29.5001C30.8807 27.25 32.0001 26.1306 32.0001 24.75V7.25C32.0001 5.86938 30.8807 4.75 29.5001 4.75Z",
    fill: "#50DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1251 24.75V7.25C10.1251 5.86931 11.2444 4.75 12.6251 4.75H4.92599C4.11206 5.50181 3.38074 6.34156 2.74512 7.25287V24.7471C3.38074 25.6584 4.11206 26.4982 4.92599 27.25H12.6251C11.2444 27.25 10.1251 26.1307 10.1251 24.75Z",
    fill: "#38C674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2916 9.74125C28.0085 9.63563 27.0004 8.56063 27.0004 7.25H2.74537C2.4645 7.6525 2.20281 8.06938 1.96094 8.49881V23.5012C2.20281 23.9306 2.4645 24.3475 2.74537 24.75H27.0004C27.0004 23.4394 28.0085 22.3644 29.2916 22.2588C29.3604 22.2531 29.4304 22.25 29.5004 22.25V9.75C29.4304 9.75 29.3604 9.74688 29.2916 9.74125Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 21.2142V10.7858C27.1861 10.4086 26.3414 9.56394 25.9642 8.5H1.96056C0.712749 10.7167 0 13.2749 0 16C0 18.725 0.712749 21.2833 1.96056 23.5H25.9642C26.3414 22.436 27.1861 21.5914 28.25 21.2142Z",
    fill: "#38C674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 18.7251 0.71275 21.2833 1.96056 23.5H10.125V8.5H1.96056C0.71275 10.7168 0 13.2749 0 16Z",
    fill: "#2AB663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4375 7.25C30.4375 7.76775 30.0178 8.1875 29.5 8.1875C28.9822 8.1875 28.5625 7.76775 28.5625 7.25C28.5625 6.73225 28.9822 6.3125 29.5 6.3125C30.0178 6.3125 30.4375 6.73225 30.4375 7.25Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4375 24.75C30.4375 25.2678 30.0178 25.6875 29.5 25.6875C28.9822 25.6875 28.5625 25.2678 28.5625 24.75C28.5625 24.2322 28.9822 23.8125 29.5 23.8125C30.0178 23.8125 30.4375 24.2322 30.4375 24.75Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 16C19.8125 19.1066 17.2941 21.625 14.1875 21.625C11.0809 21.625 8.5625 19.1066 8.5625 16C8.5625 12.8934 11.0809 10.375 14.1875 10.375C17.2941 10.375 19.8125 12.8934 19.8125 16Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 20.375C11.7751 20.375 9.8125 18.4124 9.8125 16C9.8125 13.5876 11.7751 11.625 14.1875 11.625C16.5999 11.625 18.5625 13.5876 18.5625 16C18.5625 18.4124 16.5999 20.375 14.1875 20.375Z",
    fill: "#38C674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 16C12.9375 14.2708 13.7181 12.724 14.9458 11.6921C14.6993 11.6489 14.4462 11.625 14.1875 11.625C11.7751 11.625 9.8125 13.5876 9.8125 16C9.8125 18.4124 11.7751 20.375 14.1875 20.375C14.4462 20.375 14.6993 20.3511 14.9458 20.3079C13.7181 19.276 12.9375 17.7293 12.9375 16Z",
    fill: "#2AB663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 17.25H22.625C21.9346 17.25 21.375 16.6904 21.375 16C21.375 15.3096 21.9346 14.75 22.625 14.75H25.75C26.4404 14.75 27 15.3096 27 16C27 16.6904 26.4404 17.25 25.75 17.25Z",
    fill: "#2AB663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 14.125C25.4375 14.8154 24.8779 15.375 24.1875 15.375C23.4971 15.375 22.9375 14.8154 22.9375 14.125C22.9375 13.4346 23.4971 12.875 24.1875 12.875C24.8779 12.875 25.4375 13.4346 25.4375 14.125Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 17.875C25.4375 18.5654 24.8779 19.125 24.1875 19.125C23.4971 19.125 22.9375 18.5654 22.9375 17.875C22.9375 17.1846 23.4971 16.625 24.1875 16.625C24.8779 16.625 25.4375 17.1846 25.4375 17.875Z",
    fill: "#70F2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 17.25H5.75C6.44037 17.25 7 16.6904 7 16C7 15.3096 6.44037 14.75 5.75 14.75H2.625C1.93463 14.75 1.375 15.3096 1.375 16C1.375 16.6904 1.93463 17.25 2.625 17.25Z",
    fill: "#1BA552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 14.125C2.9375 14.8154 3.49712 15.375 4.1875 15.375C4.87787 15.375 5.4375 14.8154 5.4375 14.125C5.4375 13.4346 4.87787 12.875 4.1875 12.875C3.49712 12.875 2.9375 13.4346 2.9375 14.125Z",
    fill: "#38C674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 17.875C2.9375 18.5654 3.49712 19.125 4.1875 19.125C4.87787 19.125 5.4375 18.5654 5.4375 17.875C5.4375 17.1846 4.87787 16.625 4.1875 16.625C3.49712 16.625 2.9375 17.1846 2.9375 17.875Z",
    fill: "#38C674"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterOfferMoney);
export default __webpack_public_path__ + "static/media/counterOfferMoney.7f229d9fcaa2320a9e92fd23bfbe6b6d.svg";
export { ForwardRef as ReactComponent };